// extracted by mini-css-extract-plugin
export default {"actionsMenu":"ActivityActionsMenu__actionsMenu___uC5Eb","deleteButton":"ActivityActionsMenu__deleteButton___GP5ZO","moreIcon":"ActivityActionsMenu__moreIcon___citbk"};